module.exports = __webpack_public_path__ + "img/hr-puberty-decal-22.8508043a.png";